angular.module("tromanWeb").factory('ListConfiguration', ['$log', function ($log) {

    function ListConfiguration(metadata) {
        /// <param name="definition" value="{ properties: [] }">Definition</param>

        this._properties = metadata.properties.filter(function (x) {
            return angular.isDefined(x.list);
        }).map(function (x) {
            return angular.copy(x);
        });

        this.title = (metadata.title || "").toString();

        this.selectedColumns = this._properties.filter(function (x) { return x.list.defcol > 0; });
        this.availableColumns = this._properties.filter(function (x) { return x.list.defcol === 0; });

        this.selectedSorters = this._properties.filter(function (x) { return x.list.defsort > 0; });
        this.availableSorters = this._properties.filter(function (x) { return x.list.defsort === 0; });
    }

    function moveItem(dst, src, key) {
        var pos = src.findIndex(function (x) { return x.key === key; });
        if (pos < 0) {
            $log.debug("Property not found.");
            return;
        }

        var item = src[pos];
        dst.push(item);
        src.splice(pos, 1);
        return item;
    }

    function compareProperty(a, b) {
        return a.order - b.order;
    }

    ListConfiguration.prototype.addColumn = function addColumn(item) {
        moveItem(this.selectedColumns, this.availableColumns, item.key);
    };
    ListConfiguration.prototype.removeColumn = function removeColumn(item) {
        moveItem(this.availableColumns, this.selectedColumns, item.key);
        this.availableColumns.sort(compareProperty);
    };
    ListConfiguration.prototype.addSorter = function addSorter(item) {
        moveItem(this.selectedSorters, this.availableSorters, item.key);
    };
    ListConfiguration.prototype.removeSorter = function removeSorter(item) {
        moveItem(this.availableSorters, this.selectedSorters, item.key);
        this.availableSorters.sort(compareProperty);
    };

    ListConfiguration.prototype.store = function store() {
        return {
            title: this.title,
            columns: this.selectedColumns.map(function (x) { return x.key; }),
            sorters: this.selectedSorters.map(function (x) {
                return {
                    key: x.key,
                    asc: !!x.ascending
                };
            })
        };
    };

    ListConfiguration.prototype.load = function load(data) {
        var self = this;

        self.title = data.title;
        self.selectedColumns = [];
        self.selectedSorters = [];
        self.availableColumns = self._properties.slice();
        self.availableSorters = self._properties.slice();

        data.columns.forEach(function (x) {
            moveItem(self.selectedColumns, self.availableColumns, x);
        });
        data.sorters.forEach(function (x) {
            var item = moveItem(self.selectedSorters, self.availableSorters, x.key);
            item.ascending = x.asc;
        });
    };

    return ListConfiguration;
}]);
